
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 12.53 17.25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M3.74 5.37V3.53a2.53 2.53 0 1 1 5 0v1.84a6.1 6.1 0 0 1 1 .56v-2.4a3.53 3.53 0 1 0-7 0v2.4a6.1 6.1 0 0 1 1-.56z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M6.27 4.72A6.27 6.27 0 1 0 12.53 11a6.27 6.27 0 0 0-6.26-6.28zm0 11.53A5.27 5.27 0 1 1 11.53 11a5.27 5.27 0 0 1-5.26 5.25z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M5.15 13.8l-2.4-2.4a.5.5 0 0 1 .71-.71l1.69 1.7 3.71-3.71a.5.5 0 0 1 .71.71z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M6.27 17.25A6.27 6.27 0 1 1 12.53 11a6.27 6.27 0 0 1-6.26 6.25zm0-11.53A5.27 5.27 0 1 0 11.53 11a5.27 5.27 0 0 0-5.26-5.28z"}})])])])
          )
        }
      }
    